<template>
  <div class="p-img" :style="styles">
    <!-- v-bind="$attrs" -->
    <el-image
      :lazy="lazy"
      :src="srcPath"
      @load="(e) => $emit('load', e)"
      @error="(e) => $emit('error', e)"
    ></el-image>
    <AuthMark v-if="auth" class="auth-mark" />
  </div>
</template>
<script>
import AuthMark from "@/components/authMark/Index";
export default {
  name: "p-img",
  components: {
    AuthMark,
  },
  props: {
    local: {
      type: Boolean,
      default: false,
    },
    lazy: {
      type: Boolean,
      default: true,
    },
    width: {
      type: String,
    },
    height: {
      type: String,
    },
    radius: {
      type: String,
    },
    fontSize: {
      type: String,
    },
    auth: {
      type: [Boolean, Number, String, Object],
      default: false,
    },
  },
  computed: {
    srcPath() {
      /* local  support @/assets/img/ category only     */
      const { local } = this.$props;
      const { src = "" } = this.$attrs;
      const srcPath = local ? this.require(src) : this.$tools.fullUrl(src);
      return srcPath;
    },
    styles() {
      const { width, height, radius: borderRadius, fontSize } = this.$props;
      return {
        width,
        height,
        borderRadius,
        "--font-size": fontSize || "14px",
      };
    },
  },
  methods: {
    require(src) {
      try {
        const path = src.replace("@/assets/img/", "");
        return require("@/assets/img/" + path);
      } catch (error) {
        return;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.p-img {
  position: relative;
  overflow: hidden;
  .el-image {
    width: 100%;
    height: 100%;
    ::v-deep .el-image__error {
      font-size: var(--font-size);
    }
  }
  .auth-mark {
    position: absolute;
    bottom: 0;
    right: 50%;
    transform: translateX(50%);
  }
}
</style>
